<template>
    <v-container fluid>
        <confirm-modal
          :dialog="showConfirm"
          :message="confirmMessage"
          @confirm="confirmResponse($event)">
        </confirm-modal>

        <loader :show="$anyLoading()" :message="messageLoader"></loader>

        <!-- breadcrumb, header -->
        <v-layout row wrap>
            <v-flex md10 offset-md1 xs12 offset-xs0 mb-2>
              <div class="mt-2">
                <span class="green--text">Torneos</span>
                <span class="ml-3 mr-3">></span>
                <span>{{this.currentTournament ? currentTournament.name : 'Nuevo Torneo'}}</span>
                <span class="ml-3 mr-3">></span>
                <span>Sanciones</span>
              </div>

              <div class="layout row wrap mt-2 calendar-header">
                <v-btn color="green"
                  class="ml-auto"
                  @click="submit"
                  v-if="currentTournament.status != 'finalized'">
                  Guardar Cambios
                </v-btn>
              </div>
            </v-flex>
        </v-layout>
        <v-layout row class="calendar">
            <!-- main content -->
            <v-flex md10 offset-md1 xs12 offset-xs0>
                <h5 class="green--text">Sanciones del Torneo</h5>

                <p class="subheading">Jornadas</p>

                <v-tabs v-model="selectedtab">
                    <v-tabs-bar class="transparent" left>
                      <v-tabs-slider color="green"></v-tabs-slider>
                      <v-tabs-item
                          v-cloak
                          v-for="(set, i) in sets"
                          :key="i"
                          :href="'#set' + i">

                          <div @click="setCurrentSet(set)">
                              <p class="subheading mb-0">{{ setTabHeading(set,i) }}</p>
                              <span>{{ set.type }}</span>
                          </div>
                      </v-tabs-item>
                    </v-tabs-bar>

                    <v-tabs-items>
                        <v-tabs-content
                            v-for="(set, i) in sets"
                            :key="i"
                            :id="'set' + i">

                            <div class="matches-wrapper">
                              <p class="subheading mt-3 mb-2">Sanciones</p>

                              <v-card class="match">
                                <textarea class="textarea" v-model="set.text" />
                              </v-card>
                              <v-card class="match">
                                <div class="add-btn text-xs-right">
                                  <v-btn color="green" @click="openNewSanctionModal()" v-if="currentTournament.status != 'finalized'">
                                    Agregar Sanción
                                  </v-btn>
                                </div>
                                <v-data-table
                                  v-if="currentSet"
                                  :rows-per-page-items="[25,50,100]"
                                  :headers="headers"
                                  :items="currentSet.sanctions"
                                  class="elevation-1"
                                  light
                                  hide-actions
                                  rows-per-page-text="Filas por página">
                                  <template slot="items" slot-scope="props">
                                    <td>{{ props.item.name }}</td>
                                    <td>{{ props.item.number_player }}</td>
                                    <td>{{ props.item.team }}</td>
                                    <td>{{ props.item.category }}</td>
                                    <td>{{ props.item.causal }}</td>
                                    <td>{{ props.item.sanction }}</td>
                                    <td class="text-xs-left green--text">
                                      <v-tooltip left>
                                        <v-btn
                                            @click="removeSanction(props.item)"
                                            flat
                                            icon
                                            light
                                            slot="activator">
                                          <v-icon>delete</v-icon>
                                        </v-btn>
                                        <span>Eliminar sanción</span>
                                      </v-tooltip>
                                    </td>
                                  </template>
                                </v-data-table>
                              </v-card>
                            </div>
                        </v-tabs-content>
                    </v-tabs-items>
                </v-tabs>

                <footer class="calendar-footer">
                  <div class="mt-3">
                    <v-btn @click="cancel" flat color="red" v-if="currentTournament.status != 'finalized'">
                      Cancelar
                    </v-btn>
                    <v-btn color="green" @click="submit" v-if="currentTournament.status != 'finalized'">
                      Guardar Cambios
                    </v-btn>
                  </div>
                </footer>
            </v-flex>
        </v-layout>
        <new-sanction-modal
            :dialog="showNewSanction"
            :error="newSanctionError"
            @response="addNewSanction($event)"
            @cancel="closeModal($event)">
        </new-sanction-modal>
    </v-container>
</template>

<script>
import NewSanctionModal from './NewSanctionModal'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
    name: 'Sanctions',
    components: {
        NewSanctionModal
    },
    data() {
        return {
          selectedtab:null,
            fab: false,
            notify:false,
            showConfirm: false,
            confirmMessage:"",
            confirmType:"",
            messageLoader: 'Cargando Información',
            currentSet: null,
            sanctionToDelete:null,
            showNewSanction: false,
            newSanctionError: '',
            months: {
                'January': 'Enero',
                'February': 'Febrero',
                'March': 'Marzo',
                'April': 'Abril',
                'May': 'Mayo',
                'June': 'Junio',
                'July': 'Julio',
                'August': 'Agosto',
                'September': 'Septiembre',
                'October': 'Octubre',
                'November': 'Noviembre',
                'December': 'Diciembre'
            },
            selectedSanction: null,
            headers: [
                { text: 'Nombre', value: 'name', align: 'left' },
                { text: 'Numero', value: 'number_player', align: 'left' },
                { text: 'Equipo', value: 'team', align: 'left' },
                { text: 'Categoría', value: 'category', align: 'left' },
                { text: 'Causal', value: 'causal', align: 'left' },
                { text: 'Sanción', value: 'sanction', align: 'left' },
                { text: '', value: 'actions', align: 'left' }
            ],
        }
    },
    created() {
        if(this.$route.params.tournamentID) {
            this.findTournament(this.$route.params.tournamentID)
            this.loadSanctions(this.currentTournament.id)
        }
    },
    computed: {
        ...mapGetters([
            'currentTournament',
            'sanctions'
        ]),
        sets() {
            return this.sanctions;
        }
    },
    watch: {
        currentTournament(tournament) {
            this.mixinSets()
        }
    },
    methods: {
        ...mapActions([
            'findTournament',
            'updateSets',
            'loadSanctions',
            'updateSetSanctions'
        ]),
        closeModal(modal) {
            switch(modal) {
                case 'newsanctionmodal':
                    this.newSanctionError = ''
                    this.showNewSanction = false
                    break;
            }
        },
        orderSets() {
            let tempSets = []
            let extraSets = []

            this.sets.forEach(set => {
                if(set.type === 'regular') {
                    tempSets.push(set)
                } else {
                    extraSets.push(set)
                }
            })

            extraSets = this.orderExtraSets(extraSets)
            extraSets.forEach(set => {
                tempSets.push(set)
            })

            return tempSets
        },
        orderExtraSets(extraSets) {
            let tempExtraSets = extraSets.slice()
            let firstPosition = 0

            tempExtraSets.forEach((set, j) => {
                firstPosition = this.getExtraSetPosition(set.type)
                for(let i = 0, x = tempExtraSets.length; i < x; i++) {
                    if(firstPosition > this.getExtraSetPosition(tempExtraSets[i].type)) {
                        [tempExtraSets[j], tempExtraSets[i]] = [tempExtraSets[i], tempExtraSets[j]]
                    }
                }
            })

            return tempExtraSets

        },
        getExtraSetPosition(extraSetName) {
            let position = 0

            switch(extraSetName) {
                case '1/16':
                    position = 5
                    break;
                case '1/8':
                    position = 4
                    break;
                case '1/4':
                    position = 3
                    break;
                case 'semi':
                    position = 2
                    break;
                case 'final':
                    position = 1
                    break;
            }

            return position
        },
        addNewSanction(sanction) {
          if(sanction){
            this.currentSet.sanctions.push(sanction);
          }
          this.showNewSanction = false
        },
        openNewSanctionModal() {
          this.showNewSanction = true
        },
        sanctionSelected(data) {

        },
        removeSanction(sanction){
          this.sanctionToDelete = sanction
          this.showConfirm = true
          this.confirmMessage = "¿Está seguro de borrar la sanción?"
          this.confirmType = "sanction"
        },
        confirmResponse(response){
          this.showConfirm = false
          if(response){
            if(this.confirmType == "sanction"){
              this.currentSet.sanctions.splice(this.currentSet.sanctions.indexOf(this.sanctionToDelete),1)
            }
          }
        },
        setCurrentSet(set){
          this.currentSet = set
        },
        setCurrentSetPosition(i) {
        },
        mixinSets() {
          if(this.currentTournament){
            if(this.currentSet){
              this.currentSet = this.findObjByID(this.sets, this.currentSet.id)
            }
            console.log('currentset', this.currentSet)
            this.currentSet = this.currentSet == null ? this.sets[0] : this.currentSet
          }
        },
        findObjByID(array,id){
          for(var i in array){
            if(array[i].id == id){
              return array[i]
            }
          }
          return null
        },
        setTabHeading(set,index){
          index+=1
          if(set.type == "regular"){
            return "Jornada "+index
          }else{
            return this.dayFormat(set.start_date)
          }
        },
        submit() {
            //this.messageLoader = 'Guardando Cambios...'
            this.updateSetSanctions(this.sets)
        },
        cancel(){
          this.loadSanctions(this.currentTournament.id)
          this.mixinSets()
        }
    }
}
</script>

<style lang="css" scoped>
/* general calendar */
.calendar {
  align-items: flex-start;
}

.calendar-header {
  align-items: center;
}

.calendar-header .subheading {
  line-height: 1.35;
}

@media screen and (max-width: 600px) {
  .calendar-header .subheading {
    width: 100%;
  }

  .calendar-header .btn {
    margin: 15px 0 10px;
  }
}

.calendar-footer {
  text-align: right;
  padding-bottom : 40px;
}

.calendar-footer .tooltip {
  display: inline-block;
  min-width: 190px;
}

.edit-icon-calendar .material-icons {
    font-size: 18px;
}


/* helpers */
.ml-auto {
  margin-left: auto;
}

.flex-align-center {
  display: flex;
  align-items: center;
}


/* speed-dial */
.speed-dial {
  bottom: 50px;
  right: 15px;
  z-index: 99;
}

.speed-dial >>> .btn[data-label]::after {
  content: attr(data-label);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  line-height: 1;
  white-space: nowrap;
}

.speed-dial >>> .btn.label-left::after {
  right: calc(100% + 10px);
}

/* wrappers */
.matches-wrapper,
.calendar-footer {
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
}

.textarea {
  width: 100%;
}

.add-btn {
  width: 100%;
} 

</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/sanctions/Sanctions.vue